class cartDrawerSamples extends HTMLElement {
  constructor() {
    super();
    this.openers = this.querySelectorAll('[data-samples-items], [data-samples-choose]');
    this.dialog = this.querySelector('[data-samples-dialog]');
    this.closeButton = this.querySelector('[data-samples-close]');
    this.submitButton = this.querySelector('[data-samples-submit]');
    this.counters = this.querySelectorAll('[data-samples-counter]');
    this.removeForm = this.querySelector('[data-samples-remove]');
    this.removeOldForm = this.querySelector('[data-samples-remove-old]');

    this.maxQuantity = this.dataset.samplesMaxQuantity;
    this.isAlone = this.maxQuantity === '1';
    this.checkedProductsCount = this.querySelectorAll('[data-samples-input]:checked').length;
  }

  connectedCallback() {
    this.openDialog = this.openDialog.bind(this);
    this.closeDialog = this.closeDialog.bind(this);
    this.onInputChecked = this.onInputChecked.bind(this);
    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.removeSamples = this.removeSamples.bind(this);

    this.openers.forEach((opener) => opener.addEventListener('click', this.openDialog));
    this.closeButton.addEventListener('click', this.closeDialog);
    this.dialog.addEventListener('change', this.onInputChecked);
    this.dialog.addEventListener('submit', this.onFormSubmit);
    this.removeForm.addEventListener('submit', this.removeSamples);
    this.removeOldForm.addEventListener('submit', this.removeSamples);

    this.limitQuantityOfSamples();

    // check if this.removeOldForm has inputs
    if (this.removeOldForm.querySelectorAll('input').length !== 0) {
      const removeOldEvent = new Event('submit', { bubbles: true });
      this.removeOldForm.dispatchEvent(removeOldEvent);
    }

    if (this.hasAttribute('data-should-remove-samples')) {
      const removeEvent = new Event('submit', { bubbles: true });
      this.removeForm.dispatchEvent(removeEvent);
    }
  }

  disconnectedCallback() {
    this.openers.forEach((opener) => opener.removeEventListener('click', this.openDialog));
    this.closeButton.removeEventListener('click', this.closeDialog);
    this.dialog.removeEventListener('change', this.onInputChecked);
    this.dialog.removeEventListener('submit', this.onFormSubmit);
    this.removeForm.removeEventListener('submit', this.removeSamples);
    this.removeOldForm.removeEventListener('submit', this.removeSamples);
  }

  removeSamples(event) {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
    const button = event.currentTarget.querySelector('button');
    if (cartItems) cartItems.updateQuantities(null, null, formData);
    if (button) {
      button.classList.add('loading');
      button.querySelector('.loading-overlay__spinner').classList.remove('hidden');
    }
  }

  onFormSubmit(event) {
    event.preventDefault();
    this.enableLoading();
    const formData = new FormData(event.currentTarget);

    const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
    cartItems.updateQuantities(null, null, formData);
  }

  enableLoading() {
    this.submitButton.classList.add('loading');
    this.submitButton.setAttribute('disabled', 'disabled');
    this.submitButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');
  }

  onInputChecked(event) {
    // If we can only have one checkbox checked at a time, we need to uncheck the others
    if (this.isAlone && event.target.checked) {
      this.querySelectorAll('[data-samples-input]:checked').forEach((input) => {
        if (input !== event.target) {
          input.checked = false;
        }
      });

      event.target.classList.remove('disabled');

      if (this.checkedProductsCount < 1) this.checkedProductsCount++;
    } else if (event.target.checked) {
      this.checkedProductsCount++;
    } else {
      this.checkedProductsCount--;
    }

    this.limitQuantityOfSamples();

    this.counters.forEach((counter) => {
      counter.textContent = counter.textContent.replace(/.*\//, `${this.checkedProductsCount}/`);
    });
  }

  limitQuantityOfSamples() {
    const checkedInputs = this.querySelectorAll('[data-samples-input]:checked');
    const uncheckedInputs = this.querySelectorAll('[data-samples-input]:not(:checked)');
    if (checkedInputs.length >= this.maxQuantity) {
      uncheckedInputs.forEach((input) => {
        if (this.isAlone) {
          input.classList.add('disabled');
        } else {
          input.setAttribute('disabled', 'disabled');
        }
      });
    } else {
      uncheckedInputs.forEach((input) => {
        if (this.isAlone) {
          input.classList.remove('disabled');
        } else {
          input.removeAttribute('disabled');
        }
      });
    }
  }

  openDialog() {
    this.dialog.setAttribute('aria-hidden', 'false');
    trapFocus(this.dialog, this.closeButton);
  }

  closeDialog() {
    this.dialog.setAttribute('aria-hidden', 'true');
    removeTrapFocus(this.querySelector('[data-samples-choose]'));
  }
}

customElements.define('cart-drawer-samples', cartDrawerSamples);